/**
 * FileType
 * Enum representing file types.
 *
 * @property IMAGE - Image file.
 * @property VIDEO - Video file.
 * @property AUDIO - Audio file.
 * @property APPLICATION - Application file.
 * @property FILE - Generic file.
 */
export enum FileType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  APPLICATION = 'application',
  FILE = 'file',
}
